export default "__VITE_ASSET__BlROEGek__"